import { render, staticRenderFns } from "./SupplierComponent.vue?vue&type=template&id=d1b5f268&scoped=true"
import script from "./SupplierComponent.vue?vue&type=script&lang=js"
export * from "./SupplierComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b5f268",
  null
  
)

export default component.exports